/**
 * The redesign's stat tile (guide §3): an eyebrow, a Geist Mono 500 28 number, then an optional 12 px muted
 * hint. Tiles group inside a radius-12 frame that shares 1 px `--color-border-subtle` gaps between them.
 */
export function StatTile({
  label,
  value,
  hint,
  footer,
  tone = "default",
}: {
  label: string;
  value: React.ReactNode;
  hint?: string;
  /** A link or action under the hint (PracticeOverview's "Review gaps →"). */
  footer?: React.ReactNode;
  /** `fail` paints the number `--color-fail-text` (e.g. pending authority gaps). */
  tone?: "default" | "fail";
}): JSX.Element {
  return (
    <div className="tile">
      <span className="eyebrow">{label}</span>
      <span className={`tile__value${tone === "fail" ? " tile__value--fail" : ""}`}>{value}</span>
      {hint === undefined ? null : <span className="tile__hint">{hint}</span>}
      {footer === undefined ? null : footer}
    </div>
  );
}

export function StatTileGroup({
  label,
  children,
}: {
  /** Accessible name for the group (the tiles themselves carry no heading). */
  label: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <section className="tiles" aria-label={label}>
      {children}
    </section>
  );
}
